export const translations = {
  pt: {
    nav: {
      about: 'Quem Somos',
      triangle: 'Triângulo Estratégico',
      pillars: 'Pilares',
      partners: 'Parceiros',
      partnersAssociates: 'Parceiros & Associados',
      usa: 'BACC USA',
      services: 'Serviços',
      membership: 'Associação',
      testimonials: 'Depoimentos',
      blog: 'Blog',
      courses: 'Cursos',
      contact: 'Contato',
      events: 'Eventos',
      join: 'Associe-se',
      memberArea: 'Área do Associado',
      institutional: 'Institucional',
      business: 'Negócios'
    },
    hero: {
      title: 'A Ponte Entre Três Continentes',
      subtitle: 'Conectando Brasil, EUA e Ásia através de oportunidades estratégicas de negócios, diplomacia econômica e parcerias de alto impacto.',
      cta1: 'Fale com a BACC',
      cta2: 'Associe-se Agora',
      scroll: 'Deslize para descobrir'
    },
    about: {
      title: 'Quem Somos',
      subtitle: 'Integração econômica, cultural e social',
      text1: 'A Brasil Asia Câmara de Comércio (BACC) é uma instituição dedicada a promover a integração econômica, cultural e social entre o Brasil e as nações do continente asiático. Fundada em 2026, nossa organização nasceu da necessidade de criar um canal direto, seguro e eficiente para empresas e investidores que buscam expandir suas fronteiras.',
      text2: 'Atuamos como um elo estratégico, facilitando o diálogo entre governos, instituições privadas e empreendedores. Nossa expertise reside em decodificar as complexidades dos mercados asiáticos para os brasileiros e apresentar o potencial do Brasil para os asiáticos, sempre com foco na geração de valor mútuo.',
      text3: 'Mais do que uma câmara de comércio, somos uma plataforma de conexão global. Entendemos que negócios duradouros são construídos sobre a base sólida da confiança e do entendimento cultural.',
      quote: 'Nossa missão é transformar distâncias geográficas em proximidade comercial.',
      hq: 'Sede Brasil',
      address: 'Mubadalla Office Building - Rua Inácio Higino, 673, sala 603, Praia da Costa - Vila Velha - ES'
    },
    triangle: {
      title: 'O Triângulo Estratégico',
      tagline: 'Três Continentes. Uma Câmara. Infinitas Oportunidades.',
      brazil: 'Brasil',
      brazilCity: 'Vila Velha, ES',
      brazilDesc: 'Sede Principal',
      usa: 'Estados Unidos',
      usaCity: 'North Charleston, SC',
      usaDesc: 'Chapter USA',
      asia: 'Ásia',
      asiaCount: '50+ Países',
      asiaDesc: 'Mercados Alvo',
      benefit1: 'Acesso Global',
      benefit1Desc: 'Rede de parceiros em três continentes',
      benefit2: 'Suporte Institucional',
      benefit2Desc: 'Apoio governamental e diplomático',
      benefit3: 'Hub Integrado',
      benefit3Desc: 'Plataforma unificada de negócios'
    },
    pillars: {
      title: 'Nossos 12 Pilares',
      subtitle: 'Os fundamentos que guiam nossa atuação global',
      items: [
        { name: 'Integridade e Transparência', desc: 'A base de todas as nossas relações' },
        { name: 'Excelência e Profissionalismo', desc: 'Padrão de alto desempenho' },
        { name: 'Inovação e Adaptabilidade', desc: 'Sempre à frente das mudanças' },
        { name: 'Respeito à Diversidade Cultural', desc: 'Valorizamos cada cultura' },
        { name: 'Colaboração e Parceria', desc: 'Juntos chegamos mais longe' },
        { name: 'Compromisso com Resultados', desc: 'Foco em gerar valor real' },
        { name: 'Ética nas Relações Comerciais', desc: 'Negócios com integridade' },
        { name: 'Sustentabilidade', desc: 'Compromisso com o futuro' },
        { name: 'Liderança Visionária', desc: 'Guiando o caminho para a Ásia' },
        { name: 'Inclusão e Equidade', desc: 'Oportunidades para todos' },
        { name: 'Responsabilidade Social', desc: 'Impacto positivo na sociedade' },
        { name: 'Conexão Global', desc: 'Brasil e Ásia, unidos pelo comércio' }
      ]
    },
    partners: {
      title: 'Países Parceiros',
      subtitle: 'Conectando você aos principais mercados asiáticos',
      countries: ['China', 'Índia', 'Japão', 'Coreia do Sul', 'Singapura', 'Vietnã', 'Malásia', 'Tailândia', 'Indonésia', 'Paquistão', 'Bangladesh', 'Sri Lanka']
    },
    usa: {
      title: 'BACC Chapter USA',
      subtitle: 'Sua porta de entrada para o mercado americano',
      location: 'North Charleston, SC',
      address: '4700 Goer Drive, Suite 200A, North Charleston, SC 29406, USA',
      ecosystemTitle: 'Ecossistema de Parceiros',
      ecosystem: ['BMW', 'Boeing', 'Michelin', 'Mercedes-Benz'],
      servicesTitle: 'Serviços Oferecidos',
      services: ['Abertura de LLC/Corp', 'Suporte Legal & Contábil', 'Acesso ao Porto de Charleston']
    },
    services: {
      title: 'O que Oferecemos',
      subtitle: 'Soluções completas para sua expansão internacional',
      categories: [
        { title: 'Desenvolvimento de Mercados', items: ['Inteligência de Mercado', 'Matchmaking B2B', 'Missões Comerciais', 'Feiras Internacionais'] },
        { title: 'Operacional & Compliance', items: ['Abertura de Empresas', 'Suporte Jurídico', 'Contabilidade Internacional', 'Logística & Supply Chain'] },
        { title: 'Diplomacia & Marca', items: ['Relações Governamentais', 'Eventos Institucionais', 'PR & Comunicação', 'Networking Exclusivo'] }
      ]
    },
    membership: {
      title: 'Planos de Associação',
      subtitle: 'Escolha o plano ideal para sua empresa',
      plans: [
        { name: 'Bronze', price: 'R$ 500', period: '/mês', features: ['Acesso a eventos', 'Newsletter exclusiva', 'Diretório de membros'] },
        { name: 'Prata', price: 'R$ 1.200', period: '/mês', features: ['Tudo do Bronze', 'Matchmaking trimestral', 'Relatórios setoriais'] },
        { name: 'Ouro', price: 'R$ 2.500', period: '/mês', features: ['Tudo do Prata', 'Inteligência personalizada', 'Missões exclusivas'], popular: true },
        { name: 'Diamante', price: 'R$ 5.000', period: '/mês', features: ['Tudo do Ouro', 'Acesso a governos', 'Clusters setoriais'] },
        { name: 'Institucional', price: 'Sob Consulta', period: '', features: ['Solução personalizada', 'Parceria estratégica', 'Benefícios exclusivos'] }
      ],
      cta: 'Escolher Plano'
    },
    testimonials: {
      title: 'Depoimentos',
      subtitle: 'O que nossos associados dizem',
      items: [
        { quote: 'A BACC foi fundamental para nossa entrada no mercado asiático. O suporte e a rede de contatos são incomparáveis.', name: 'Carlos Mendes', role: 'CEO', company: 'TechExport Brasil' },
        { quote: 'A estrutura do Chapter USA facilitou toda nossa operação de importação. Recomendo fortemente.', name: 'Ana Silva', role: 'Diretora Comercial', company: 'AgroSul Ltda' },
        { quote: 'As missões comerciais organizadas pela BACC geraram negócios reais e parcerias duradouras.', name: 'Roberto Chen', role: 'Fundador', company: 'Asia Link Trading' }
      ]
    },
    blog: {
      title: 'Blog & Notícias',
      subtitle: 'Últimas novidades do comércio internacional',
      readMore: 'Ler mais',
      noPosts: 'Nenhuma publicação disponível no momento.',
      categories: { news: 'Notícias', article: 'Artigos', event: 'Eventos', market: 'Mercado', negocios: 'Negócios', cultura: 'Cultura', comercio: 'Comércio', trade: 'Comércio' }
    },
    courses: {
      title: 'Cursos & Capacitação',
      subtitle: 'Desenvolva suas competências em comércio internacional',
      duration: 'Duração',
      level: 'Nível',
      levels: { beginner: 'Iniciante', intermediate: 'Intermediário', advanced: 'Avançado' },
      membersOnly: 'Exclusivo para Associados',
      accessCourse: 'Acessar Curso',
      noCourses: 'Nenhum curso disponível no momento.',
      loginRequired: 'Faça login como associado para acessar este curso.'
    },
    contact: {
      title: 'Entre em Contato',
      subtitle: 'Estamos prontos para ajudar sua empresa a crescer',
      form: {
        name: 'Nome Completo',
        email: 'E-mail',
        phone: 'Telefone',
        company: 'Empresa',
        interest: 'Área de Interesse',
        interests: ['Exportação', 'Importação', 'Investimentos', 'Abertura de Empresa', 'Missões Comerciais', 'Outro'],
        message: 'Mensagem',
        submit: 'Enviar Mensagem',
        success: 'Mensagem enviada com sucesso!',
        error: 'Erro ao enviar. Tente novamente.'
      },
      brazil: { title: 'Brasil - Sede', phone: '+55 27 2018-1349', email: 'contato@bacc.org.br' },
      usa: { title: 'USA - Chapter', phone: '+1 843 555-0100', email: 'usa@bacc.org' }
    },
    footer: {
      description: 'Conectando Brasil, Estados Unidos e Ásia através de oportunidades estratégicas de negócios.',
      quickLinks: 'Links Rápidos',
      legal: 'Legal',
      privacy: 'Política de Privacidade',
      terms: 'Termos de Uso',
      social: 'Redes Sociais',
      rights: '© 2024 BACC - Brasil Asia Chamber of Commerce. Todos os direitos reservados.',
      poweredBy: 'Desenvolvido com'
    },
    memberPortal: {
      title: 'Área do Associado',
      login: 'Entrar',
      logout: 'Sair',
      email: 'E-mail',
      password: 'Senha',
      welcome: 'Bem-vindo',
      dashboard: 'Painel',
      myCourses: 'Meus Cursos',
      documents: 'Documentos',
      profile: 'Perfil',
      loginError: 'E-mail ou senha incorretos',
      plan: 'Plano',
      company: 'Empresa',
      noDocuments: 'Nenhum documento disponível para seu plano.',
      downloadDoc: 'Baixar Documento'
    },
    admin: {
      title: 'Painel Administrativo',
      login: 'Entrar',
      logout: 'Sair',
      email: 'E-mail',
      password: 'Senha',
      dashboard: 'Dashboard',
      contacts: 'Contatos',
      testimonials: 'Depoimentos',
      blog: 'Blog',
      courses: 'Cursos',
      members: 'Associados',
      documents: 'Documentos',
      content: 'Conteúdo',
      save: 'Salvar',
      delete: 'Excluir',
      edit: 'Editar',
      add: 'Adicionar',
      loginError: 'Credenciais inválidas',
      noContacts: 'Nenhum contato encontrado',
      contactDetails: 'Detalhes do Contato',
      published: 'Publicado',
      draft: 'Rascunho'
    }
  },
  en: {
    nav: {
      about: 'About Us',
      triangle: 'Strategic Triangle',
      pillars: 'Pillars',
      partners: 'Partners',
      partnersAssociates: 'Partners & Associates',
      usa: 'BACC USA',
      services: 'Services',
      membership: 'Membership',
      testimonials: 'Testimonials',
      blog: 'Blog',
      courses: 'Courses',
      contact: 'Contact',
      events: 'Events',
      join: 'Join Us',
      memberArea: 'Member Area',
      institutional: 'Institutional',
      business: 'Business'
    },
    hero: {
      title: 'The Bridge Between Three Continents',
      subtitle: 'Connecting Brazil, USA, and Asia through strategic business opportunities, economic diplomacy, and high-impact partnerships.',
      cta1: 'Talk to BACC',
      cta2: 'Join Now',
      scroll: 'Scroll to discover'
    },
    about: {
      title: 'About Us',
      subtitle: 'Economic, cultural and social integration',
      text1: 'The Brasil Asia Chamber of Commerce (BACC) is an institution dedicated to promoting economic, cultural and social integration between Brazil and the nations of the Asian continent. Founded in 2026, our organization was born from the need to create a direct, safe and efficient channel for companies and investors seeking to expand their boundaries.',
      text2: 'We act as a strategic link, facilitating dialogue between governments, private institutions and entrepreneurs. Our expertise lies in decoding the complexities of Asian markets for Brazilians and presenting Brazil\'s potential to Asians, always focused on generating mutual value.',
      text3: 'More than a chamber of commerce, we are a global connection platform. We understand that lasting business is built on the solid foundation of trust and cultural understanding.',
      quote: 'Our mission is to transform geographical distances into commercial proximity.',
      hq: 'Brazil Headquarters',
      address: 'Mubadalla Office Building - Rua Inácio Higino, 673, room 603, Praia da Costa - Vila Velha - ES'
    },
    triangle: {
      title: 'The Strategic Triangle',
      tagline: 'Three Continents. One Chamber. Infinite Opportunities.',
      brazil: 'Brazil',
      brazilCity: 'Vila Velha, ES',
      brazilDesc: 'Headquarters',
      usa: 'United States',
      usaCity: 'North Charleston, SC',
      usaDesc: 'USA Chapter',
      asia: 'Asia',
      asiaCount: '50+ Countries',
      asiaDesc: 'Target Markets',
      benefit1: 'Global Access',
      benefit1Desc: 'Partner network across three continents',
      benefit2: 'Institutional Support',
      benefit2Desc: 'Government and diplomatic backing',
      benefit3: 'Integrated Hub',
      benefit3Desc: 'Unified business platform'
    },
    pillars: {
      title: 'Our 12 Pillars',
      subtitle: 'The foundations that guide our global operations',
      items: [
        { name: 'Leadership', desc: 'Excellence in corporate governance' },
        { name: 'Ethics', desc: 'Integrity in all relationships' },
        { name: 'Competitiveness', desc: 'Sustainable competitive advantage' },
        { name: 'Cultural Diversity', desc: 'Respect for differences' },
        { name: 'Sustainability', desc: 'Environmental commitment' },
        { name: 'Legal Security', desc: 'Legal compliance' },
        { name: 'Governance', desc: 'Transparent management' },
        { name: 'Connectivity', desc: 'Integrated global networks' },
        { name: 'Innovation', desc: 'Cutting-edge technology' },
        { name: 'Economic Diplomacy', desc: 'Institutional relations' },
        { name: 'Executive Education', desc: 'Continuous training' },
        { name: 'Results', desc: 'Performance focused' }
      ]
    },
    partners: {
      title: 'Partner Countries',
      subtitle: 'Connecting you to major Asian markets',
      countries: ['China', 'India', 'Japan', 'South Korea', 'Singapore', 'Vietnam', 'Malaysia', 'Thailand', 'Indonesia', 'Pakistan', 'Bangladesh', 'Sri Lanka']
    },
    usa: {
      title: 'BACC Chapter USA',
      subtitle: 'Your gateway to the American market',
      location: 'North Charleston, SC',
      address: '4700 Goer Drive, Suite 200A, North Charleston, SC 29406, USA',
      ecosystemTitle: 'Partner Ecosystem',
      ecosystem: ['BMW', 'Boeing', 'Michelin', 'Mercedes-Benz'],
      servicesTitle: 'Services Offered',
      services: ['LLC/Corp Formation', 'Legal & Accounting Support', 'Access to Port of Charleston']
    },
    services: {
      title: 'What We Offer',
      subtitle: 'Complete solutions for your international expansion',
      categories: [
        { title: 'Market Development', items: ['Market Intelligence', 'B2B Matchmaking', 'Trade Missions', 'International Fairs'] },
        { title: 'Operations & Compliance', items: ['Company Formation', 'Legal Support', 'International Accounting', 'Logistics & Supply Chain'] },
        { title: 'Diplomacy & Brand', items: ['Government Relations', 'Institutional Events', 'PR & Communications', 'Exclusive Networking'] }
      ]
    },
    membership: {
      title: 'Membership Plans',
      subtitle: 'Choose the ideal plan for your company',
      plans: [
        { name: 'Bronze', price: '$100', period: '/month', features: ['Event access', 'Exclusive newsletter', 'Member directory'] },
        { name: 'Silver', price: '$250', period: '/month', features: ['Everything in Bronze', 'Quarterly matchmaking', 'Sector reports'] },
        { name: 'Gold', price: '$500', period: '/month', features: ['Everything in Silver', 'Custom intelligence', 'Exclusive missions'], popular: true },
        { name: 'Diamond', price: '$1,000', period: '/month', features: ['Everything in Gold', 'Government access', 'Sector clusters'] },
        { name: 'Institutional', price: 'Contact Us', period: '', features: ['Custom solution', 'Strategic partnership', 'Exclusive benefits'] }
      ],
      cta: 'Choose Plan'
    },
    testimonials: {
      title: 'Testimonials',
      subtitle: 'What our members say',
      items: [
        { quote: 'BACC was instrumental in our entry into the Asian market. The support and network of contacts are unparalleled.', name: 'Carlos Mendes', role: 'CEO', company: 'TechExport Brasil' },
        { quote: 'The USA Chapter structure facilitated our entire import operation. Highly recommended.', name: 'Ana Silva', role: 'Commercial Director', company: 'AgroSul Ltda' },
        { quote: 'The trade missions organized by BACC generated real business and lasting partnerships.', name: 'Roberto Chen', role: 'Founder', company: 'Asia Link Trading' }
      ]
    },
    blog: {
      title: 'Blog & News',
      subtitle: 'Latest news from international trade',
      readMore: 'Read more',
      noPosts: 'No posts available at the moment.',
      categories: { news: 'News', article: 'Articles', event: 'Events', market: 'Market', negocios: 'Business', cultura: 'Culture', comercio: 'Trade', trade: 'Trade' }
    },
    courses: {
      title: 'Courses & Training',
      subtitle: 'Develop your skills in international trade',
      duration: 'Duration',
      level: 'Level',
      levels: { beginner: 'Beginner', intermediate: 'Intermediate', advanced: 'Advanced' },
      membersOnly: 'Members Only',
      accessCourse: 'Access Course',
      noCourses: 'No courses available at the moment.',
      loginRequired: 'Log in as a member to access this course.'
    },
    contact: {
      title: 'Get in Touch',
      subtitle: 'We are ready to help your company succeed in the Brazilian and USA markets.',
      form: {
        name: 'Full Name',
        email: 'Email',
        phone: 'Phone',
        company: 'Company',
        interest: 'Area of Interest',
        interests: ['Export', 'Import', 'Investments', 'Company Formation', 'Trade Missions', 'Other'],
        message: 'Message',
        submit: 'Send Message',
        success: 'Message sent successfully!',
        error: 'Error sending. Please try again.'
      },
      brazil: { title: 'Brazil - Headquarters', phone: '+55 27 2018-1349', email: 'contato@bacc.org.br' },
      usa: { title: 'USA - Chapter', phone: '+1 843 555-0100', email: 'usa@bacc.org' }
    },
    footer: {
      description: 'Connecting Brazil, United States, and Asia through strategic business opportunities.',
      quickLinks: 'Quick Links',
      legal: 'Legal',
      privacy: 'Privacy Policy',
      terms: 'Terms of Use',
      social: 'Social Media',
      rights: '© 2024 BACC - Brasil Asia Chamber of Commerce. All rights reserved.',
      poweredBy: 'Powered by'
    },
    memberPortal: {
      title: 'Member Area',
      login: 'Login',
      logout: 'Logout',
      email: 'Email',
      password: 'Password',
      welcome: 'Welcome',
      dashboard: 'Dashboard',
      myCourses: 'My Courses',
      documents: 'Documents',
      profile: 'Profile',
      loginError: 'Invalid email or password',
      plan: 'Plan',
      company: 'Company',
      noDocuments: 'No documents available for your plan.',
      downloadDoc: 'Download Document'
    },
    admin: {
      title: 'Admin Panel',
      login: 'Login',
      logout: 'Logout',
      email: 'Email',
      password: 'Password',
      dashboard: 'Dashboard',
      contacts: 'Contacts',
      testimonials: 'Testimonials',
      blog: 'Blog',
      courses: 'Courses',
      members: 'Members',
      documents: 'Documents',
      content: 'Content',
      save: 'Save',
      delete: 'Delete',
      edit: 'Edit',
      add: 'Add',
      loginError: 'Invalid credentials',
      noContacts: 'No contacts found',
      contactDetails: 'Contact Details',
      published: 'Published',
      draft: 'Draft'
    }
  },
  zh: {
    nav: {
      about: '关于我们',
      triangle: '战略三角',
      pillars: '支柱',
      partners: '合作伙伴',
      partnersAssociates: '合作伙伴与会员',
      usa: 'BACC美国',
      services: '服务',
      membership: '会员',
      testimonials: '评价',
      blog: '博客',
      courses: '课程',
      contact: '联系',
      events: '活动',
      join: '加入我们',
      memberArea: '会员专区',
      institutional: '机构',
      business: '商业'
    },
    hero: {
      title: '三大洲之间的桥梁',
      subtitle: '通过战略商业机会、经济外交和高影响力合作伙伴关系连接巴西、美国和亚洲。',
      cta1: '联系BACC',
      cta2: '立即加入',
      scroll: '滚动发现更多'
    },
    about: {
      title: '关于我们',
      subtitle: '经济、文化和社会融合',
      text1: '巴西亚洲商会（BACC）是一个致力于促进巴西与亚洲各国之间经济、文化和社会融合的机构。成立于2026年，我们的组织的诞生是为了满足企业和投资者寻求拓展边界的需求，提供直接、安全和高效的渠道。',
      text2: '我们作为战略纽带，促进政府、私营机构和企业家之间的对话。我们的专长在于为巴西人解读亚洲市场的复杂性，并向亚洲人展示巴西的潜力，始终专注于创造互利价值。',
      text3: '不仅仅是一个商会，我们是一个全球连接平台。我们理解，持久的业务建立在信任和文化理解的坚实基础上。',
      quote: '我们的使命是将地理距离转化为商业亲近。',
      hq: '巴西总部',
      address: 'Mubadalla Office Building - Rua Inácio Higino, 673, 603室, Praia da Costa - Vila Velha - ES'
    },
    triangle: {
      title: '战略三角',
      tagline: '三大洲。一个商会。无限机遇。',
      brazil: '巴西',
      brazilCity: '维拉维利亚',
      brazilDesc: '总部',
      usa: '美国',
      usaCity: '北查尔斯顿',
      usaDesc: '美国分会',
      asia: '亚洲',
      asiaCount: '50+国家',
      asiaDesc: '目标市场',
      benefit1: '全球访问',
      benefit1Desc: '三大洲合作伙伴网络',
      benefit2: '机构支持',
      benefit2Desc: '政府和外交支持',
      benefit3: '综合中心',
      benefit3Desc: '统一的商业平台'
    },
    pillars: {
      title: '我们的12个支柱',
      subtitle: '指导我们全球运营的基础',
      items: [
        { name: '领导力', desc: '卓越的公司治理' },
        { name: '道德', desc: '所有关系中的诚信' },
        { name: '竞争力', desc: '可持续的竞争优势' },
        { name: '文化多样性', desc: '尊重差异' },
        { name: '可持续性', desc: '环境承诺' },
        { name: '法律安全', desc: '法律合规' },
        { name: '治理', desc: '透明管理' },
        { name: '连通性', desc: '综合全球网络' },
        { name: '创新', desc: '尖端技术' },
        { name: '经济外交', desc: '机构关系' },
        { name: '高管教育', desc: '持续培训' },
        { name: '结果', desc: '专注于绩效' }
      ]
    },
    partners: {
      title: '合作国家',
      subtitle: '将您与主要亚洲市场连接',
      countries: ['中国', '印度', '日本', '韩国', '新加坡', '越南', '马来西亚', '泰国', '印度尼西亚', '巴基斯坦', '孟加拉国', '斯里兰卡']
    },
    usa: {
      title: 'BACC美国分会',
      subtitle: '您进入美国市场的门户',
      location: '北查尔斯顿，SC',
      address: '4700 Goer Drive, Suite 200A, North Charleston, SC 29406, USA',
      ecosystemTitle: '合作伙伴生态系统',
      ecosystem: ['BMW', 'Boeing', 'Michelin', 'Mercedes-Benz'],
      servicesTitle: '提供的服务',
      services: ['LLC/公司成立', '法律和会计支持', '查尔斯顿港口通道']
    },
    services: {
      title: '我们提供什么',
      subtitle: '为您的国际扩张提供完整的解决方案',
      categories: [
        { title: '市场开发', items: ['市场情报', 'B2B配对', '贸易考察团', '国际展会'] },
        { title: '运营与合规', items: ['公司注册', '法律支持', '国际会计', '物流与供应链'] },
        { title: '外交与品牌', items: ['政府关系', '机构活动', '公关与传播', '专属网络'] }
      ]
    },
    membership: {
      title: '会员计划',
      subtitle: '为您的公司选择理想的计划',
      plans: [
        { name: '青铜', price: '¥700', period: '/月', features: ['活动参与', '专属通讯', '会员目录'] },
        { name: '白银', price: '¥1,800', period: '/月', features: ['青铜所有权益', '季度配对', '行业报告'] },
        { name: '黄金', price: '¥3,500', period: '/月', features: ['白银所有权益', '定制情报', '专属考察团'], popular: true },
        { name: '钻石', price: '¥7,000', period: '/月', features: ['黄金所有权益', '政府通道', '行业集群'] },
        { name: '机构', price: '咨询', period: '', features: ['定制解决方案', '战略合作', '专属权益'] }
      ],
      cta: '选择计划'
    },
    testimonials: {
      title: '评价',
      subtitle: '我们的会员怎么说',
      items: [
        { quote: 'BACC对我们进入亚洲市场起到了关键作用。支持和联系网络无与伦比。', name: 'Carlos Mendes', role: 'CEO', company: 'TechExport Brasil' },
        { quote: '美国分会的结构促进了我们整个进口业务。强烈推荐。', name: 'Ana Silva', role: '商务总监', company: 'AgroSul Ltda' },
        { quote: 'BACC组织的贸易考察团产生了真正的业务和持久的合作伙伴关系。', name: 'Roberto Chen', role: '创始人', company: 'Asia Link Trading' }
      ]
    },
    blog: {
      title: '博客与新闻',
      subtitle: '国际贸易最新动态',
      readMore: '阅读更多',
      noPosts: '暂无文章。',
      categories: { news: '新闻', article: '文章', event: '活动', market: '市场', negocios: '商业', cultura: '文化', comercio: '贸易', trade: '贸易' }
    },
    courses: {
      title: '课程与培训',
      subtitle: '提升您的国际贸易技能',
      duration: '时长',
      level: '级别',
      levels: { beginner: '初级', intermediate: '中级', advanced: '高级' },
      membersOnly: '会员专享',
      accessCourse: '进入课程',
      noCourses: '暂无课程。',
      loginRequired: '请登录会员账户访问此课程。'
    },
    contact: {
      title: '联系我们',
      subtitle: '我们随时准备帮助您的公司在巴西和美国市场取得成功。',
      form: {
        name: '全名',
        email: '电子邮件',
        phone: '电话',
        company: '公司',
        interest: '感兴趣领域',
        interests: ['出口', '进口', '投资', '公司注册', '贸易考察团', '其他'],
        message: '留言',
        submit: '发送消息',
        success: '消息发送成功！',
        error: '发送错误。请重试。'
      },
      brazil: { title: '巴西 - 总部', phone: '+55 27 2018-1349', email: 'contato@bacc.org.br' },
      usa: { title: '美国 - 分会', phone: '+1 843 555-0100', email: 'usa@bacc.org' }
    },
    footer: {
      description: '通过战略商业机会连接巴西、美国和亚洲。',
      quickLinks: '快速链接',
      legal: '法律',
      privacy: '隐私政策',
      terms: '使用条款',
      social: '社交媒体',
      rights: '© 2024 BACC - 巴西亚洲商会。保留所有权利。',
      poweredBy: '技术支持'
    },
    memberPortal: {
      title: '会员专区',
      login: '登录',
      logout: '退出',
      email: '电子邮件',
      password: '密码',
      welcome: '欢迎',
      dashboard: '仪表板',
      myCourses: '我的课程',
      documents: '文档',
      profile: '个人资料',
      loginError: '邮箱或密码错误',
      plan: '计划',
      company: '公司',
      noDocuments: '您的计划没有可用文档。',
      downloadDoc: '下载文档'
    },
    admin: {
      title: '管理面板',
      login: '登录',
      logout: '退出',
      email: '电子邮件',
      password: '密码',
      dashboard: '仪表板',
      contacts: '联系人',
      testimonials: '评价',
      blog: '博客',
      courses: '课程',
      members: '会员',
      documents: '文档',
      content: '内容',
      save: '保存',
      delete: '删除',
      edit: '编辑',
      add: '添加',
      loginError: '凭据无效',
      noContacts: '未找到联系人',
      contactDetails: '联系详情',
      published: '已发布',
      draft: '草稿'
    }
  }
};
